import {NgModule} from '@angular/core';
import {AccordionModule} from 'primeng/accordion';
import {AvatarModule} from 'primeng/avatar';
import {AutoCompleteModule} from 'primeng/autocomplete';
import {ButtonModule} from 'primeng/button';
import {ChipModule} from 'primeng/chip';
import {CardModule} from 'primeng/card';
import {CheckboxModule} from 'primeng/checkbox';
import {ColorPickerModule} from 'primeng/colorpicker';
import {DatePickerModule} from 'primeng/datepicker';
import {IconFieldModule} from 'primeng/iconfield';
import {InputIconModule} from 'primeng/inputicon';
import {DialogModule} from 'primeng/dialog';
import {InputNumberModule} from 'primeng/inputnumber';
import {InputTextModule} from 'primeng/inputtext';
import {MenuModule} from 'primeng/menu';
import {MessageModule} from 'primeng/message';
import {MultiSelectModule} from 'primeng/multiselect';
import {ProgressBarModule} from 'primeng/progressbar';
import {ProgressSpinnerModule} from 'primeng/progressspinner';
import {RadioButtonModule} from 'primeng/radiobutton';
import {PaginatorModule} from 'primeng/paginator';
import {SelectModule} from 'primeng/select';
import {StepperModule} from 'primeng/stepper';
import {TableModule} from 'primeng/table';
import {TabsModule} from 'primeng/tabs';
import {TagModule} from 'primeng/tag';
import {TextareaModule} from 'primeng/textarea';
import {ToggleSwitchModule} from 'primeng/toggleswitch';
import {DrawerModule} from 'primeng/drawer';
import {TooltipModule} from 'primeng/tooltip';

const PRIME_MODULES = [
	AccordionModule,
	AvatarModule,
	AutoCompleteModule,
	ButtonModule,
	ChipModule,
	CardModule,
	CheckboxModule,
	ColorPickerModule,
	DatePickerModule,
	IconFieldModule,
	InputIconModule,
	DialogModule,
	InputNumberModule,
	InputTextModule,
	MenuModule,
	MessageModule,
	MultiSelectModule,
	ProgressBarModule,
	ProgressSpinnerModule,
	RadioButtonModule,
	SelectModule,
	StepperModule,
	TableModule,
	PaginatorModule,
	TabsModule,
	TagModule,
	TextareaModule,
	ToggleSwitchModule,
	TooltipModule,
	DrawerModule,
];

/** PrimeNG widgets — importer via ce module. */
@NgModule({
	imports: PRIME_MODULES,
	exports: PRIME_MODULES,
})
export class PrimeUiModule {
}
